import React, { useCallback, useEffect } from 'react'
import { withRouter } from "react-router"
import { Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik'
import * as Yup from 'yup';
import { sanitizeFormInput } from '../../../../functions/formFunctions';
import Translation from '../../../Translation/cont/Translation';
import FieldWrapper from '../../../forms/FieldWrapper';
import MultiselectCheckboxCinemasRow from '../../../forms/fields/MultiselectCheckboxCinemasRow';
import sortCinemas from '../../../../functions/sortCinemas';


const PushCreateForm = ({ cliCinemas, clientCinemaId, item, onUpdateItem, enabledCinemaIds, onResetForm }) => {

    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
    item["cinemasFilter"] = cliCinemasIdList
    
    const debouncedUpdate = useCallback(
        _.debounce((updatedValues) => {
            onUpdateItem(updatedValues);	
        }, 300),
        []
      );

    return (
        <Formik
            initialValues={sanitizeFormInput(item)}
            validateOnBlur={false}
            validateOnChange={true}
            validateOnMount={true}
            validationSchema={validationSchema}
        >
        {({values}) => (
                <Form>
                        { 
                            useEffect(() => {
                                let valid = validationSchema.isValidSync(sanitizeFormInput(values))
                                const updatedWithValidity = {
                                    ...values,
                                    valid: valid
                                };
                                
                                debouncedUpdate(updatedWithValidity);

                                return () => {
                                    debouncedUpdate.cancel();
                                };
                        }, [values, values.cinemasFilter.length])}
                        <ErrorMessage className="text-regular-color movie-error" name="style" component="div" /> 
                        <fieldset className="">
                            <FieldWrapper label={<Translation id="push_create_title" />} id="push-title" classes="field-text">
                                <Field name="title" type="text" maxLength="20" id="push-title" className="text-small-light input-text-box" />
                                <ErrorMessage name="title" component="div" />
                            </FieldWrapper>

                            <FieldWrapper label={<Translation id="push_create_body" />} info={<Translation id="push_create_body"/>} id="push-body" classes="field-textarea field-textarea-text">
                                <Field name="body" component="textarea" cols="50" wrap="hard" maxLength="220" id="push-body" className="text-small-light input-text-box" />
                                <ErrorMessage name="body" component="div" />
                            </FieldWrapper>
                        </fieldset>

                        {cliCinemas ? (
                            <MultiselectCheckboxCinemasRow clientCinemaId={clientCinemaId} cliCinemas={cliCinemas} enabledCinemaIds={enabledCinemaIds} />
                                ) : (
                                    ''
                                )
                        }     
                            
                </Form>
            )}

        </Formik>
    )
}

const validationSchema = Yup.object().shape({
    title: Yup.string().required(<Translation id="formik_field_required" />),
    body: Yup.string().required(<Translation id="formik_field_required" />)
  });

export default withRouter(PushCreateForm) 